/* Ported from Faded Lore v4.5: carousel lifecycle, free-mode loop, navigation and swipe analytics.
   PDP data/options/add differ; the existing cart role normalizer remains the sole bundle-role owner. */
(function () {
  'use strict';
  if (customElements.get('wq-pdp-upsell')) return;
  var ROOT = (window.Shopify && Shopify.routes.root) || '/', carouselId = 0;
  var episodes = new Set(), activeEpisodes = new Map();
  function node(tag, cls, text) { var el = document.createElement(tag); if (cls) el.className = cls; if (text != null) el.textContent = text; return el; }
  async function request(path, init) { var r = await fetch(ROOT + path, init); if (!r.ok) throw new Error('Request failed'); return r.json(); }
  function publish(name, data) {
    try { var p = Shopify.analytics.publish(name, data); if (p && p.catch) p.catch(function () {}); } catch (_) {}
  }
  function flushSwipes(context) {
    episodes.forEach(function (episode) {
      if (context && episode.context !== context) return;
      if (!episode.sent && episode.beyondSecond) {
        episode.sent = true;
        publish('wq_pdp_upsell_swipe', { mode: episode.mode, max_position_seen: episode.max });
      }
      episodes.delete(episode);
    });
    if (context) activeEpisodes.delete(context); else activeEpisodes.clear();
  }
  function options(p) { return { color: p.options.findIndex(function (o) { return /^colou?r$/i.test(o.name); }), size: p.options.findIndex(function (o) { return /^size$/i.test(o.name); }) }; }
  function image(p, v, selectedColor) {
    var ci = options(p).color;
    var color = String(selectedColor || (v && ci >= 0 && v.options[ci]) || 'Pepper').toLowerCase();
    function src(m) { return typeof m === 'string' ? m : m && (m.src || m.url || (m.preview_image && m.preview_image.src)) || ''; }
    var media = (p.media || []).filter(function (m) { return !m.media_type || m.media_type === 'image'; });
    var altMatch = media.find(function (m) { return src(m) && String(m.alt || '').toLowerCase().indexOf('in ' + color) !== -1; });
    if (altMatch) return src(altMatch);
    var fileMatch = media.concat(p.images || []).find(function (m) {
      var url = src(m); if (!url) return false;
      var filename = url.split('?')[0].split('/').pop();
      try { filename = decodeURIComponent(filename); } catch (_) {}
      return filename.toLowerCase().indexOf(color) !== -1;
    });
    return src(fileMatch) || src(p.featured_image);
  }

  async function suggestions(id) {
    var list = [], seen = new Set([String(id)]);
    function take(rows) { (rows || []).forEach(function (p) { if (!seen.has(String(p.id)) && p.type !== 'Membership' && p.product_type !== 'Membership' && p.available !== false) { seen.add(String(p.id)); list.push(p); } }); }
    for (var intent of ['complementary', 'related']) {
      try { take((await request('recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=10&intent=' + intent)).products); } catch (_) {}
    }
    { try { take((await request('collections/all/products.json?limit=250')).products); } catch (_) {} }
    var products = [];
    for (var offset=0;offset<list.length && products.length<6;offset+=6) {
    var batch = await Promise.all(list.slice(offset,offset+6).map(async function (p) {
      try {
        var full = await request('products/' + encodeURIComponent(p.handle) + '.js');
        var response = await fetch(ROOT + 'products/' + encodeURIComponent(p.handle) + '?section_id=wq-pdp-upsell-tile');
        if (!response.ok) return null;
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        full.priceTemplates = new Map(Array.from(doc.querySelectorAll('template[data-wq-price]')).map(function (t) { return [t.dataset.wqPrice, t]; }));
        return full.available && full.type !== 'Membership' && full.priceTemplates.size ? full : null;
      } catch (_) { return null; }
    }));
    products=products.concat(batch.filter(Boolean));
    }
    return products.slice(0,6);
  }
  class PdpUpsell extends HTMLElement {
    connectedCallback() {
      this.revision = (this.revision || 0) + 1; var revision = this.revision;
      this.mode = 'pdp'; this.state = []; this.opened = new Set();
      this.sizeListener = (e) => { this.mainSize = e.detail.size; if (this.list) this.list.forEach((p,i) => { var o = options(p); if (!this.state[i].sizeEdited && o.size >= 0) { this.state[i].size = p.options[o.size].values.includes(this.mainSize) ? this.mainSize : ''; this.sync(i); } }); };
      document.addEventListener('wq:main-size', this.sizeListener);
      this.priceListener=()=>{if(this.list)this.list.forEach((p,i)=>this.sync(i));}; document.addEventListener('wq:pricing-change',this.priceListener);
      suggestions(this.dataset.productId).then((list) => {
        if (!this.isConnected || revision !== this.revision || !list.length) return;
        this.mainSize = document.querySelector('.fl-b')?.dataset.selectedSize || ''; this.render(list); this.hidden = false; this.initCarousel();
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some(e => e.isIntersecting) || this.episode) return;
          this.episode = {context:'pdp',mode:'pdp',max:1,beyondSecond:false,sent:false}; episodes.add(this.episode);
          publish('wq_pdp_upsell_view', {mode:'pdp',product_ids:list.map(p=>p.id)}); this.updateCarousel();
        }); this.observer.observe(this);
      }).catch(() => { this.hidden = true; });
    }
    disconnectedCallback() { this.revision++; this.destroyCarousel(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); document.removeEventListener('wq:main-size',this.sizeListener); document.removeEventListener('wq:pricing-change',this.priceListener); flushSwipes('pdp'); }
    destroyCarousel() {
      if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; }
    }
    markCopies(swiper) {
      Array.from(swiper.slides || []).forEach(function (slide) {
        if (!slide.classList.contains('swiper-slide-duplicate')) return;
        slide.setAttribute('aria-hidden', 'true'); slide.querySelectorAll('button,select,a').forEach(function (el) { el.tabIndex = -1; });
        slide.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; img.decoding = 'async'; });
      });
    }
    initCarousel() {
      if (!this.track || this.hidden || !this.isConnected) return;
      var drawer = this.closest('m-cart-drawer');
      if (drawer && !drawer.classList.contains('m-cart-drawer--active')) return;
      if (!this.track.clientWidth) return;
      const Swiper = window.MinimogLibs && window.MinimogLibs.Swiper;
      var k = window.innerWidth >= 750 ? 3 : 2.2;
      if (!Swiper) { this.measureFallback(); this.updateCarousel(); return; }
      if (this.swiper && this.visibleCount === k) return;
      var index = this.swiper ? this.swiper.realIndex : (this.activeIndex || 0);
      this.destroyCarousel(); this.visibleCount = k;
      this.track.classList.add('swiper'); this.wrapper.style.display = ''; this.wrapper.classList.add('swiper-wrapper');
      var owner = this;
      this.swiper = new Swiper(this.track, {
        slidesPerView: 2.2, spaceBetween: 10, breakpoints: { 750: { slidesPerView: 3 } },
        initialSlide: index, loopedSlides: Math.ceil(k), loop: this.tiles.length > k, speed: 350,
        grabCursor: true, watchSlidesProgress: true,
        // Bundled Minimog Swiper uses the pre-module free mode API.
        freeMode: true, freeModeSticky: true,
        on: {
          init: function () { owner.markCopies(this); owner.updateCarousel(this); },
          slideChange: function () { owner.updateCarousel(this); },
          setTranslate: function () { owner.updateCarousel(this); },
          loopFix: function () { owner.markCopies(this); },
          touchStart: function () { owner.interaction = true; },
          sliderMove: function () { owner.interaction = true; owner.userMoved = true; owner.updateCarousel(this); },
          touchEnd: function () { owner.dragged = !!this.allowClick === false; }
        }
      });
      this.markCopies(this.swiper); this.updateCarousel();
    }
    measureFallback() {
      this.track.classList.remove('swiper'); this.wrapper.classList.remove('swiper-wrapper'); this.wrapper.style.display = 'contents';
      var left = this.track.scrollLeft, base = this.track.getBoundingClientRect().left;
      this.positions = this.tiles.map(function (tile) { return tile.getBoundingClientRect().left - base + left; });
      this.viewportWidth = this.track.clientWidth;
      this.scrollEnd = Math.max(0, this.track.scrollWidth - this.viewportWidth);
      this.step = this.positions.length > 1 ? this.positions[1] - this.positions[0] : this.viewportWidth;
    }
    moveTile(direction) {
      this.interaction = true; this.userMoved = true;
      if (this.swiper) { if (direction < 0) this.swiper.slidePrev(); else this.swiper.slideNext(); }
      else this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
      this.updateCarousel();
    }
    goToTile(index) {
      this.interaction = true; this.userMoved = true;
      if (this.swiper) { if (this.swiper.params.loop) this.swiper.slideToLoop(index); else this.swiper.slideTo(index); }
      else this.track.scrollTo({ left: this.positions[index], behavior: 'smooth' });
      this.updateCarousel();
    }
    updateCarousel(instance) {
      if (!this.track || !this.tiles.length || !this.dots) return;
      var sw = instance || this.swiper, n = this.tiles.length;
      var left = this.track.scrollLeft, end = this.scrollEnd || 0;
      var active = sw ? Number(sw.realIndex) || 0 : Math.max(0, Math.min(n - 1, Math.round(left / (this.step || 1))));
      if (!sw && left > 0 && left >= end - 1) active = n - 1;
      active = ((active % n) + n) % n; this.activeIndex = active;
      if (this.dotIndex !== active) this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        if (i === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      this.dotIndex = active;
      var loop = sw && sw.params.loop;
      this.prev.disabled = loop ? false : sw ? !!sw.isBeginning : left <= 1;
      this.next.disabled = loop ? false : sw ? !!sw.isEnd : left >= end - 1;
      this.prev.hidden = this.next.hidden = n <= 3 || (!sw && end <= 1);
      if (this.episode && this.interaction) {
        var visible = sw ? Math.ceil(Number(sw.params.slidesPerView) || 1) : Math.max(1, Math.round(this.viewportWidth / (this.step || 1)));
        this.episode.max = Math.min(n, Math.max(this.episode.max, active + visible));
        if (this.userMoved && this.episode.max > 2) this.episode.beyondSecond = true;
      }
    }

    variant(i) { var p=this.list[i], o=options(p), s=this.state[i]; return p.variants.find(v => (o.size<0 || v.options[o.size]===s.size) && (o.color<0 || v.options[o.color]===s.color)); }
    sync(i) {
      var p=this.list[i], s=this.state[i], v=this.variant(i), fallback=v || p.variants.find(v=>v.available) || p.variants[0];
      this.wrapper.querySelectorAll('[data-wq-index="'+i+'"]').forEach(card => {
        card.querySelectorAll('select').forEach(select => { select.value=s[select.dataset.option]; select.setAttribute('aria-invalid',String(select.dataset.option==='size' && s.tried && !s.size)); });
        var img=card.querySelector('img'); if(img) img.src=image(p,fallback,s.color);
        var price=card.querySelector('.wq-cu__prices'); price.replaceChildren(); var template=p.priceTemplates.get(String(fallback.id)); WQBundle.renderPrice(price,fallback,p,WQBundle.count(WQBundle.cart())>0);
        card.querySelector('.wq-cu__error').textContent=s.error || (s.tried && !s.size ? 'Please select a size' : '');
        var button=card.querySelector('[data-wq-add]'); button.disabled=!!s.busy || (!!v && !v.available); button.textContent=s.busy?'ADDING…':v && !v.available?'SOLD OUT':'ADD';
      });
    }
    openTile(i) { if(this.opened.has(i))return;this.opened.add(i);publish('wq_pdp_upsell_open',{mode:'pdp',product_id:this.list[i].id,position:i+1}); }
    async add(i, button) {
      var s=this.state[i], p=this.list[i]; if(s.busy)return; s.tried=true;s.error='';var v=this.variant(i);this.sync(i);
      if(!v || !v.available)return;
      s.busy=true;this.sync(i);
      try {
        await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:{_wq_role:'upsell'}}]})});
        publish('wq_pdp_upsell_add',{mode:'pdp',product_id:p.id,variant_id:v.id,price:v.price,position:i+1});
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true,addedVariantId:v.id}}));
      } catch (_) {s.error='Unable to add this tee. Please try again.';} finally{s.busy=false;this.sync(i);}
    }
    render(list) {
      this.destroyCarousel();this.list=list;this.dotIndex=null;this.activeIndex=0;this.positions=[];this.step=0;
      this.replaceChildren(node('h2','wq-cu__heading',this.dataset.heading || 'Complete your look'));
      var grid=node('div','wq-cu-track');this.track=grid;this.tiles=[];
      var wrapper=node('div','wq-cu-native-wrapper');this.wrapper=wrapper;wrapper.style.display='contents';grid.append(wrapper);
      grid.id='wq-cu-track-'+(++carouselId);grid.tabIndex=0;grid.setAttribute('aria-label','Suggested tees');
      list.forEach((p,i)=>{
        var o=options(p), color=o.color>=0?p.options[o.color].values[0]:'', sizes=o.size>=0?p.options[o.size].values:[];
        this.state[i]={color:color,size:sizes.includes(this.mainSize)?this.mainSize:'',tried:false};
        var card=node('article','wq-cu-tile wq-cu__card swiper-slide');card.dataset.wqIndex=i;
        var link=node('a','wq-cu__pick');link.href=ROOT+'products/'+encodeURIComponent(p.handle);
        var img=node('img','wq-cu__thumb');img.width=240;img.height=300;img.alt=p.title;img.loading=i<3?'eager':'lazy';link.append(img,node('span','wq-cu__card-title',p.title));card.append(link,node('div','wq-cu__prices'));
        var controls=node('div','wq-cu__options');
        function selectOption(name,values,empty) {var label=node('label','',name==='size'?'Size':'Color'),select=node('select');select.dataset.option=name;select.setAttribute('aria-label',(name==='size'?'Size':'Color')+' for '+p.title);if(empty){var opt=node('option','','Size');opt.value='';select.append(opt);}values.forEach(value=>{var opt=node('option','',value);opt.value=value;select.append(opt);});label.append(select);controls.append(label);}
        if(o.size>=0)selectOption('size',sizes,true);if(o.color>=0 && p.options[o.color].values.length>1)selectOption('color',p.options[o.color].values,false);
        var error=node('p','wq-cu__error');error.setAttribute('role','status');var add=node('button','wq-cu__card-add','ADD');add.type='button';add.dataset.wqAdd='';card.append(controls,error,add);wrapper.append(card);this.tiles.push(card);
      });this.append(grid);list.forEach((p,i)=>this.sync(i));
      var controls = node('div', 'wq-cu-navigation');
      this.prev = node('button', 'wq-cu-prev', '‹'); this.next = node('button', 'wq-cu-next', '›');
      this.prev.type = this.next.type = 'button'; this.prev.setAttribute('aria-label', 'Previous'); this.next.setAttribute('aria-label', 'Next');
      this.prev.setAttribute('aria-controls', grid.id); this.next.setAttribute('aria-controls', grid.id);
      var dots = node('div', 'wq-cu-dots'); this.dots = [];
      list.forEach((p, i) => {
        var dot = node('button', 'wq-cu-dot'); dot.type = 'button'; dot.setAttribute('aria-label', 'Show item ' + (i + 1)); dot.setAttribute('aria-controls', grid.id);
        dot.addEventListener('click', () => this.goToTile(i));
        dots.append(dot); this.dots.push(dot);
      });
      controls.hidden = list.length <= 1;
      controls.append(this.prev, dots, this.next); this.append(controls);
      this.prev.addEventListener('click', () => this.moveTile(-1));
      this.next.addEventListener('click', () => this.moveTile(1));
      grid.addEventListener('scroll', () => {
        if (this.swiper) return;
        this.userMoved = this.interaction;
        if (!this.scrollFramePending) {
          this.scrollFramePending = true;
          requestAnimationFrame(() => { this.scrollFramePending = false; if (this.track === grid) this.updateCarousel(); });
        }
      }, { passive: true });
      ['touchstart', 'wheel', 'keydown'].forEach((name) => grid.addEventListener(name, () => { this.interaction = true; }, { passive: true }));
      grid.addEventListener('pointerdown', (e) => { this.dragged = false; this.pointerStart = { x: e.clientX, y: e.clientY }; }, { passive: true });
      grid.addEventListener('pointermove', (e) => {
        if (e.buttons === 1 && this.pointerStart && Math.hypot(e.clientX - this.pointerStart.x, e.clientY - this.pointerStart.y) > 8) this.dragged = true;
      }, { passive: true });

      grid.addEventListener('change',(e)=>{var select=e.target.closest('select[data-option]'),card=select?.closest('[data-wq-index]');if(!card)return;var i=Number(card.dataset.wqIndex);this.openTile(i);this.state[i][select.dataset.option]=select.value;if(select.dataset.option==='size')this.state[i].sizeEdited=true;this.state[i].error='';this.sync(i);});
      grid.addEventListener('click',(e)=>{var card=e.target.closest('[data-wq-index]');if(!card || this.dragged || this.swiper?.allowClick===false)return;var i=Number(card.dataset.wqIndex);this.openTile(i);if(e.target.closest('[data-wq-add]')){e.preventDefault();this.add(i,e.target);}});
      if(typeof ResizeObserver!=='undefined'){this.resizeObserver=new ResizeObserver(()=>this.initCarousel());this.resizeObserver.observe(grid);}
      requestAnimationFrame(()=>{if(this.isConnected)this.initCarousel();});
    }
  }
  window.addEventListener('pagehide',function(){flushSwipes();});
  customElements.define('wq-pdp-upsell',PdpUpsell);
})();
